import { Project } from 'interfaces/project'
import IconButton from 'lib/components/buttons/icon-button'
import { Drawer } from 'lib/components/drawer/drawer'
import { ArrowLeftIcon } from 'lucide-react'
import CreateDeliverablesTable from '../create-deliverables-table'
import { DrawerState, ProjectUpdateType } from './project-drawer'

interface CreateDeliverablesContentProps {
  project: Project
  setDrawerState: (state: DrawerState) => void
  setOpen: (open: boolean) => void
  onUpdate: (project: Project, action: ProjectUpdateType) => void
}

export default function CreateDeliverablesContent({
  project,
  setDrawerState,
  setOpen,
  onUpdate,
}: CreateDeliverablesContentProps) {
  const onFinished = () => {
    onUpdate(project, ProjectUpdateType.UPDATE)
    setDrawerState('details')
  }

  return (
    <>
      <Drawer.Header setOpen={setOpen} showCloseButton={false} className="tw-static">
        <div className="tw-flex tw-items-center tw-gap-4">
          <IconButton
            size="xs"
            color="transparent"
            onClick={() => setDrawerState('details')}
            className="tw-mr-2"
            data-testid="BackButton"
          >
            <ArrowLeftIcon className="tw-text-neutral-700" />
          </IconButton>
          <div className="tw-overflow-hidden">
            <h3 className="tw-m-0 tw-truncate tw-p-0">Create Requests for &quot;{project.name}&quot;</h3>
            <p className="tw-m-0">
              Pick the request types you need and set how many of each you&apos;d like to include.
            </p>
          </div>
        </div>
      </Drawer.Header>
      <Drawer.Body className="tw-pb-0 tw-pt-4">
        <div className="tw-mt-4">
          <CreateDeliverablesTable
            projectId={project.id}
            onFinished={onFinished}
            onCancel={() => setDrawerState('details')}
          />
        </div>
      </Drawer.Body>
    </>
  )
}
